import type { Project } from '../services/api'

/** Shown on Edit/Delete when the caller is only a project viewer. */
export const VIEW_ONLY_PROJECT_TITLE = 'You have view-only access to this project'

export function projectWorkAccessMap(projects: Project[] | undefined): Map<string, boolean> {
  const map = new Map<string, boolean>()
  for (const project of projects ?? []) {
    map.set(project.id, project.can_manage_work === true)
  }
  return map
}

/**
 * True when the catalog has loaded and this project allows agents, prompts, and workflows.
 * Missing catalog or unknown project fails closed so viewers do not open edit mode.
 */
export function canManageProjectWork(
  projectId: string | null | undefined,
  accessByProjectId: ReadonlyMap<string, boolean>,
  catalogLoaded: boolean,
): boolean {
  if (!catalogLoaded || !projectId) return false
  return accessByProjectId.get(projectId) === true
}
